const formatAth = (hlookat, ath) => {
  for (let i = 0; i < 100 && Math.abs(ath - hlookat) >= 360; i++) {
    if (ath - hlookat >= 360) {
      ath -= 360
    }
    if (ath - hlookat <= -360) {
      ath += 360
    }
  }

  return ath
}

export default (krpano, hlookat, vlookat, ath, atv, cb) => {
  ath = formatAth(hlookat, ath)

  let index = 0
  const count = 25
  const hrate = (ath - hlookat) / count
  const vrate = (atv - vlookat) / count
  const animationFrame = () => {
    if (index < count) {
      krpano.call(
        `lookat(${hlookat + index * hrate},${vlookat + index * vrate}`
      )
      window.requestAnimationFrame(animationFrame)
      index++
    } else {
      cb && cb()
    }
  }
  window.requestAnimationFrame(animationFrame)
}
